import { createEnumSchemaPreprocessor } from '../../../utils/create-enum-schema-preprocessor';
import { z } from 'zod';

export const sideOfStreetAdherenceLevelOptions = [
  'Off',
  'Minimal',
  'Moderate',
  'Average',
  'Strict',
  'Adhere',
  'StronglyAdhere',
] as const;

export const sideOfStreetAdherenceLevelSchema = createEnumSchemaPreprocessor(
  z.enum(sideOfStreetAdherenceLevelOptions),
  sideOfStreetAdherenceLevelOptions
);

export type SideOfStreetAdherenceLevel = z.infer<
  typeof sideOfStreetAdherenceLevelSchema
>;
